<!-- @format -->

<ng-container *transloco="let t">
  <fudis-dialog [size]="'md'">
    <fudis-heading [level]="2" fudisDialogTitle>
      {{
        t(
          values.fromModule.type === "StudyModule"
            ? "MODULE_INFO.WARNING_PANEL.MODULE_TITLE"
            : "MODULE_INFO.WARNING_PANEL.DEGREE_PROGRAMME_TITLE"
        )
      }}
    </fudis-heading>
    <fudis-dialog-content [contentFocus]="true">
      @if (data$ | async; as data) {
        <fudis-grid [classes]="'fudis-my-md'">
          <fudis-body-text>
            {{
              t(
                values.fromModule.type === "StudyModule"
                  ? "MODULE_INFO.WARNING_PANEL.MODULE_VERSION_CHANGE_TEXT"
                  : "MODULE_INFO.WARNING_PANEL.DEGREE_PROGRAMME_VERSION_CHANGE_TEXT",
                {
                  fromModuleName: values.fromModule.name | localizedString,
                  fromCurriculumPeriods: data.fromCurriculumPeriods,
                  toCurriculumPeriods: data.toCurriculumPeriods,
                }
              )
            }}
          </fudis-body-text>
          <fudis-body-text>
            {{
              t(
                values.fromModule.type === "StudyModule"
                  ? "MODULE_INFO.WARNING_PANEL.MODULE_INFO_TEXT"
                  : "MODULE_INFO.WARNING_PANEL.DEGREE_PROGRAMME_INFO_TEXT"
              )
            }}
          </fudis-body-text>
        </fudis-grid>
      }
    </fudis-dialog-content>
    <fudis-dialog-actions>
      <fudis-button variant="secondary" [disabled]="pending" [label]="t('CANCEL')" (handleClick)="cancel()" />
      <fudis-button
        variant="primary"
        [disabled]="pending"
        [label]="
          t(
            values.fromModule.type === 'StudyModule'
              ? 'MODULE_INFO.WARNING_PANEL.MODULE_COPY_AND_REPLACE'
              : 'MODULE_INFO.WARNING_PANEL.DEGREE_PROGRAMME_COPY_AND_REPLACE'
          )
        "
        (handleClick)="copyAndReplace()" />
      <fudis-button
        variant="primary"
        [disabled]="pending"
        [label]="
          t(
            values.fromModule.type === 'StudyModule'
              ? 'MODULE_INFO.WARNING_PANEL.MODULE_REPLACE'
              : 'MODULE_INFO.WARNING_PANEL.DEGREE_PROGRAMME_REPLACE'
          )
        "
        (handleClick)="replace()" />
    </fudis-dialog-actions>
  </fudis-dialog>
</ng-container>
